import * as UI from "@iyk/ui"
import { config } from "./config.ts"

export const Footer = () => {
  return (
    <footer className="relative z-20 flex flex-col gap-24 px-4 pt-24 pb-4">
      <div className="flex flex-col">
        {config.social.map((link, idx) => (
          <a
            key={idx}
            href={link.href}
            className="text-sm text-gray-12 py-2.5 [&:not(:last-child)]:bshadow-b [&:not(:last-child)]:bshadow-gray-4 flex items-center justify-between"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex items-center gap-2">
              <link.logo />
              {link.label}
            </div>
            <UI.Icon.ArrowUpRight />
          </a>
        ))}
      </div>
      <a
        href="https://iyk.app"
        className="text-xs-upper text-gray-10"
        target="_blank"
        rel="noreferrer"
      >
        Powered by IYK
      </a>
    </footer>
  )
}
